import api from 'Application/api/api';

const deleteGeneralTemplateFile = (templateId, fileId, cancelToken = null) =>
    api.delete(`project-manager/templates/${templateId}/files/${fileId}`, {
        cancelToken,
    });

export default deleteGeneralTemplateFile;
